// extracted by mini-css-extract-plugin
module.exports = {"title-icon":"_9400a595a7--title-icon--oWbAv","title-icon-3":"_9400a595a7--title-icon-3--M6Zje","title-icon-4":"_9400a595a7--title-icon-4--Aqhp9"};